import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';
import { OpenFeature, useBooleanFlagValue } from '@openfeature/react-sdk';

const TEMPLATE_DELETE_PRO_ACTIONS_FLAG_KEY =
  'release-scribe-template-delete-pro-actions-ready-after-audit';

/**
 * Gates the redesigned note-generation recoveries in the template picker. Off
 * by default.
 *
 * Two surfaces ship under this one key, both in the template picker:
 * - template unavailable: when generation rejects the selected template
 *   because it is gone (`TemplateDeletedError` / `TemplateNotFoundError`) or
 *   no longer accessible to the user (e.g. a team template after leaving the
 *   team), the picker reopens with a warning banner (driven by
 *   `chooseNoteStructureModalTemplateUnavailableAtom`) and no toast fires;
 * - out of Pro Actions: the quota-exceeded failure reopens the picker
 *   (`chooseNoteStructureModalOutOfProActionsAtom`) instead of the paywall
 *   modal, and a non-paid user at zero Pro Actions sees the Pro-styled
 *   "select a free template" banner in place of the in-card quota footer.
 * If the two ever need independent rollout, split one onto its own key.
 *
 * OFF: the pre-redesign behaviour holds byte-for-byte — a destructive toast
 * per error code plus reopening the picker without a banner, the
 * quota-exceeded paywall modal, and the in-card quota footer.
 *
 * Haiku mounts no picker, so both paths keep their pre-redesign surface there
 * regardless of the flag.
 */
export const useIsTemplateDeleteProActionsEnabled = () =>
  useBooleanFlagValue(TEMPLATE_DELETE_PRO_ACTIONS_FLAG_KEY, false);

/** Non-hook reader for the legacy stream-response pipeline, which runs outside React. */
export const isTemplateDeleteProActionsEnabled = () =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    TEMPLATE_DELETE_PRO_ACTIONS_FLAG_KEY,
    false
  );
